import React, { useState } from "react";
import HeaderLogo from "../../../components/header/headerLogo";
import "../../../assets/scss/account/register.scss";
import Repository from "../../../configs/axios/repository";
import Swal from "sweetalert2";
import Spinner from "../../../@core/components/spinner/Fallback-spinner";

const VerifyEmail = (props) => {
    const [loadingData, setLoadingData] = useState(true);
    let value = "";
    if (props.location.state != undefined) {
        value = props.location.state.detail;
    }
    const resendEmail = async (data) => {
        const result = await Repository.findByEndPoint(
            `api/users/findUserByEmail/${value.email}`
        );
        if (result.data?.success === true) {
            setLoadingData(false);
            let newData = {
                ...value,
                verification_code: result.data.data.verification_code,
            };
            const response = await Repository.postRequest(
                `api/users/sendVerificationEmail`,
                newData
            );
            if (response.data?.success === true) {
                //
                Swal.fire({
                    text: "Your verification email has been sent. Please check your inbox to verify your account.",
                    icon: "success",
                    confirmButtonColor: "#16285e",
                });
            }
            setLoadingData(true);
        }
    };
    return loadingData ? (
        <div className="verify ">
            <div className="headerParent">
                <HeaderLogo />
            </div>
            <div className="minHeight d-flex  justify-content-md-center">
                <div className="d-block verifyContent">
                    <h1 className="resPass">VERIFY YOUR EMAIL</h1>

                    <h6 className="sentanEmail text-center">
                        You are almost there! We sent an email to
                        <p className="mailName">{value.email}</p>
                    </h6>
                    <div className="signup">
                        <h6 className="verified text-center">
                            Just click on the link in that email to complete
                            your signup. If you don't see it, you may need check
                            your spam folder.
                        </h6>
                    </div>
                    <div>
                        <h6 className="still text-center">
                            Still can't find the email?
                        </h6>
                    </div>
                    <div className="regSubmit">
                        <button
                            className="resendEmail rounded mx-auto d-block "
                            onClick={() => resendEmail()}
                        >
                            Resend Email
                        </button>
                    </div>
                    <h6 className="contactUs text-center mt-3">
                        need help?
                        <span>
                            <a href="#"> contact us</a>
                        </span>
                    </h6>
                </div>
            </div>
        </div>
    ) : (
        <Spinner spiner={true} />
    );
};

export default VerifyEmail;
